var version = "{{VERSION}}";

/**
 * Copyright (C) IRT GmbH 2020
 *
 *   BR 2020 - Audio Deskription via HbbTV 2 Interdevice Synchronisation.
 */

var AppMan = require('hbbtv-lib/main/appman');

var QS = require('hbbtv-lib/tools/query_string').get;
var debug = QS("debug");

var Logger = require('./js/tools/logging.js');
Logger.enable(debug);

function log(txt) {
	Logger.append("main.js: " + txt);
}

var _KeyEvent = require('./js/tools/keyevent_constants');

var materialResolver = require('./js/tools/materialResolver');

var MainPageMod = require('./js/widgets/main_page');
var FAQPageMod = require('./js/widgets/faq_page');
var TextPagMod = require('./js/widgets/text_page');
//var ErrPageMod = require('./js/widgets/err_page');

var DebugInfo  = require('./js/widgets/debug_info');

//var errPage = null;
var mainPage = null;

var bcVideo = null;

var SyncPlayerFactory = null;
var CSHandler = null;

var Capabilities = null;
var canCompanionSync = false;

var current_material = null;
// var current_material_error = null;

var service_not_available = null;

var companions = [];

var ATI = require('./js/tools/ati-tracking');

// In HbbTV2 -> ES5 sollte keys bereits existieren
// if (!Object.keys) {
//     Object.keys = function (obj) {
//         var keys = [],
//             k;
//         for (k in obj) {
//             if (Object.prototype.hasOwnProperty.call(obj, k)) {
//                 keys.push(k);
//             }
//         }
//         return keys;
//     };
// }

/**
 * Initialize app.
 */
window.onload = function () {
	init_gui();
	init_CSS();
};

/**
 * Initialize GUI.
 */
function init_gui() {

	AppMan.show();

	var app = document.getElementById("app");
	var faqPage = FAQPageMod(app, faqConfig)
	var imprPage = TextPagMod(app, imprintConfig, { "{{APP}}" : "BR " + appConfig.title });

	mainPage = MainPageMod(app, appConfig, faqPage, imprPage);
	mainPage.setUsageInstructions(appConfig.usageInstructions.contentAvailable);
	mainPage.setStatus(appMessages.loading_material);

	mainPage.once("close", function (url) {
		if (url) {
			window.location = url;
		} else {
			AppMan.createApp(appConfig.startleiste);
		}
	});

	//updateStatus();

	// errPage = ErrPageMod(app, appConfig);
	// errPage.setStatus("Es ist ein Fehler aufgetreten.<br/>Code 123.");

	if (debug) {
		AppMan.addKey(AppMan.BLUE);
		document.addEventListener("keydown", function(e) {
			switch (e.keyCode) {
				case _KeyEvent.VK_BLUE: case e.VK_BLUE:
					Logger.toggle();
					// console.log("toggle");
					break;
			}
		})
	}
}

/**
 * Initialize app2app communication and media synchronisation if supported by the TV.
 *
 * 1. Checks Capabilities to include Interdevice Sync with TEMI (IDS_TEMI)
 * 2. If device supports that or the URL includes debug flag continues otherwise stops
 * 3. Opens A2A websocket to wait for Companion Apps.
 * 4.
 */
function init_CSS() {
	try {
		var msp = window["hbbtvMediasyncPlayer"];

        SyncPlayerFactory = msp.SyncPlayerFactory;
        CSHandler = msp.CSHandler;
        Capabilities = msp.Capabilities;

		log(" " + version + " - " + location.href.replace("&", "&amp;"));
		log("MSP library: " + msp.Version.name + " - " + msp.Version.date);
		if (debug) {
			var app = document.getElementById("app");
			DebugInfo(app, {appVersion: version, libVersion : msp.Version.name + " - " + msp.Version.date});
		}

        Capabilities.on("debug", function (msg) {
            Logger.append("Capabilities#debug: " + msg);
		});
		Capabilities.on("error", function (where, reason) {
			Logger.append("Capabilities#error: " + where + " - " + reason);
			switch (where) {
			case "retrievecapabilities":
				canCompanionSync = false;
				updateStatus();
				break;
			}
		});
        Capabilities.on("capabilitiesavailable", function (caps) {
            Logger.append("Capabilities: " + caps);
			Logger.append("Capabilities.hasCapability(\"IDS_TEMI\") : " + Capabilities.hasCapability('IDS_TEMI'));

			canCompanionSync = Capabilities.hasCapability('IDS_TEMI');

			Logger.append("can IDS : " + canCompanionSync);

			if (debug && !canCompanionSync) {
				mainPage.setStatus("Funktion aktiviert für Debugging.");
				Logger.append("TESTING: Enable sync for all");
				canCompanionSync = true;
			}

			if (canCompanionSync) {
				CSHandler.on("debug", function (msg) {
					Logger.append("CSHandler#debug: " + msg);
				});
				CSHandler.on("cs_error", function (msg) {
					Logger.append("CSHandler#cs_error: " + msg);
				});

				CSHandler.on("connected", function (csId) {
					Logger.append("CSHandler#connected: csId: " + csId);
					connectTo(csId);

					updateStatus();

					ATI.send(ATI.EVENT2);
				});
				CSHandler.on("disconnected", function (csId) {
					try {
						Logger.append("CSHandler#disconnected: csId: " + csId);
						companions[csId] = undefined;
						delete companions[csId];

						updateStatus();

					} catch (e) {
						Logger.append("CSHandler#disconnected: " + e);
					}
				});
				CSHandler.startDiscovery();

			} else {
				// mainPage.setStatus(appMessages.dvc_not_supported);
				Logger.append("Device does not support companion sync.");
				updateStatus();
			}

			if (canCompanionSync) {
				SyncPlayerFactory.on("debug", function (msg) {
					Logger.append("SyncPlayerFactory#debug: " + msg);
				});

				SyncPlayerFactory.on("mastermediaready", function (mId) {
					try {
						Logger.append("SyncPlayerFactory#mastermediaready fired: " + mId);
						for (var csId in companions) {
							Logger.append ("Send media to CS: " + csId);
							companions[csId].addMedia(current_material.companionstreams);
						}
					} catch (e) {
						Logger.append("SyncPlayerFactory#mastermediaready: " + e);
					}
				});
				SyncPlayerFactory.on("mastermediareset", function (mId) {
					Logger.append("SyncPlayerFactory#mastermediareset fired: " + mId);
				});
				SyncPlayerFactory.on("mastermedia_syncdisabled", function (mId) {
					Logger.append("SyncPlayerFactory#mastermedia_syncdisabled fired: " + mId);
				});

				prepareBroadcast();
			}
		});
		log("UA: " + window.navigator.userAgent);
		Capabilities.retrieveCapabilities();

	} catch (e) {
		log("initCSS: " + e);
	}
};

/**
 * A companion screen connected. Get a reference to a CSSyncPlayer, that is used to control
 * the companion screen application.
 */
function connectTo(csId) {
    try {
        var csPlayer = SyncPlayerFactory.getSyncPlayer(csId);

        if (csPlayer == null) {
            log("connectTo(): connection to companion is not available: " + csId);
            return;
        }
        // csPlayer.on("debug", function (csId, msg) {
        //     info("CSSyncPlayer#debug: " + csId + " - " + msg);
        // });
        csPlayer.on("csfeatures", function (csId, features) {
            log("CSSyncPlayer#csfeatures from " + csId + ": target: " + features.target + " - mediaTypes: " + features.mediaTypes);
            // check if companion screen app announces a media type matching our slave media.
			if (current_material && current_material.companionstreams) {
                // add media info and play
                csPlayer.addMedia(current_material.companionstreams);
            } else {
				log("No material for client.");
			}
        });
        csPlayer.on("selectedmedia", function (csId, mId) {
			log("CSSyncPlayer#selectedmedia has selected: " + mId + " on " + csId);
			ATI.send(ATI.EVENT3, {slaveId : mId});
        });
        csPlayer.on("unselectedmedia", function (csId) {
            log("CSSyncPlayer#unselectedmedia on " + csId);
        });
        csPlayer.on("csmediaerror", function (csId, mId, reason) {
            log("CSSyncPlayer#csmediaerror: " + reason + " on " + csId + " for " + mId);
        });
        csPlayer.on("disabled", function (csId) {
            log("CSSyncPlayer#disabled: " + csId);
        });

        csPlayer.getFeatures();

        companions[csId] = csPlayer;

        log ("connectTo(): waiting for companion to send feature list.");
    } catch (e) {
        log ("connectTo(): " + e);
    }
}

/**
 * Initialize video/broadcast object.
 *
 * 	Bind object to current channel.
 *  Each time the playState reaches 2 continue with MRS (requestMaterial)
 */
function prepareBroadcast () {
	try {
		bcVideo = document.getElementById("bcVideo");

		// add for logging state and component changes
		bcVideo.addEventListener("PlayStateChange", function (evt) {
			log("VBO#PlayStateChange - state = " + evt.state + " - error = " + evt.error);
		}, false);

		bcVideo.addEventListener("ProgrammesChanged", function (evt) { ATI.updateProgramme(bcVideo, evt) });

		// wait for bc obj to enter presenting state
		bcVideo.addEventListener("PlayStateChange", on_bc_presenting, false);
		bcVideo.bindToCurrentChannel();
		on_bc_presenting();

	} catch (error) {
		log("prepareBroadcast: " + error);
	}
}

/**
 * Event handler listening on state changes on the V/B object to execute
 * any actions when the object reaches the PRESENTING state.
 */
function on_bc_presenting () {
	try {
		log ("on_bc_presenting " + bcVideo.playState);
		if (bcVideo.playState == 2) {
			bcVideo.removeEventListener("PlayStateChange", on_bc_presenting, false);

			var resolver = materialResolver(bcVideo.currentChannel, appConfig.mspdata_polling_ms);
			resolver.on('material_update', handle_material);
			resolver.on('error', handle_material_error);
			resolver.on('debug', Logger.append);

			ATI.on("debug", function (txt) {
				Logger.append("ATITracking: " + txt);
			});
			ATI.updateProgramme(bcVideo);
		}
	} catch (e) {
		log("on_bc_presenting: " + e);
	}
};

/**
 * Handles updates of material information.
 */
function handle_material (_current_material) {
	try {
		log("Material update received: " + _current_material.companionstreams.length + " companion streams.");

		ATI.updateSyncMaterial(_current_material);

		_current_material.master.playerRef = bcVideo;
		if (current_material === null) {
			log("First material info, set master media");
			SyncPlayerFactory.setMasterMedia(_current_material.master);

			ATI.send(ATI.EVENT1);
		}

		current_material = _current_material;
		for (var csId in companions) {
			log("reset media info for companion: " + csId);
			companions[csId].resetMedia();
			companions[csId].addMedia(current_material.companionstreams);
		}
		service_not_available = false;

		updateStatus();

	} catch (e) {
		log("exc: handle_material: " + e);
	}
}

/**
 * Handles error events from material resolver.
 *
 * @param {string} reason expect either TIMEOUT or NOTFOUND
 */
function handle_material_error (reason) {
	try {
		// current_material_error = reason;
		// log("Can't get material information " + reason);
		if (reason === "NOTFOUND") {
			service_not_available = true;
		}

		updateStatus();
	} catch (e) {
		log("exc: handle_material_error" + e);
	}
}

/**
 * Show status messages and usage instructions.
 * - Messages can be configured in config-ad.js
 * - the instruction in case no content is available is only shown on delivery networks and devices that both are supported
 * - if the no content is available instruction is shown the status field is removed from screen.
 */
function updateStatus() {
	var msg = "";
	var usage = appConfig.usageInstructions.contentAvailable;

	if (!canCompanionSync) {
		msg = appMessages.dvc_not_supported;

	} else if (service_not_available) {
		// msg = appMessages.svc_not_found;
		msg = false;
		usage = appConfig.usageInstructions.svcNotAvailable;

	} else if (current_material === null) {
		msg = appMessages.loading_material;

	} else if (current_material.companionstreams.length === 0) {
		//msg = appMessages.no_material_available;
		msg = false;
		usage = appConfig.usageInstructions.noContentAvailable;

	} else if (Object.keys(companions).length > 0) {
		msg = appMessages.app_connected;

	} else if (Object.keys(companions).length <= 0) {
		msg = appMessages.no_app_connected;
	}

	mainPage.setStatus(msg);
	mainPage.setUsageInstructions(usage);
}
